import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  Grid,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Card,
  CardMedia,
  CardActions
} from "@mui/material";

import { makeStyles } from "@material-ui/core/styles";


import AudioButton from "../../../Components/Media/AudioButton";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PauseIcon from "@mui/icons-material/Pause";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CardHeader from '@mui/material/CardHeader';
import SelectEvaluateComponent from "../../../Components/UI/SelectEvaluateComponent";

const AssessBookEvaluate = (props) => {
  //Hooks
  const styles = useStyles();
  const navigation = useNavigate();
  const dispatch = useDispatch();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { paramsdata } = useSelector((state) => state.common);

  // State
  const [logData, setLogData] = useState([]);
  const [currentIndexPlay, setCurrentIndexPlay] = useState([]);


  useEffect(() => {
    const getLearners = async () => {
      setCurrentIndexPlay(
        new Array(props.logData["outcome"]["userAnswer"][0]["ans"].length).fill(false)
      );
      setLogData(props.logData);
    };
    getLearners();
  }, [props.logData]);


  // Get class name for given id
  const setPlayMode = (status, index, end) => {    
    if (!end) {
      let arr = new Array(logData["outcome"]["userAnswer"][0]["ans"].length).fill(false);
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (end) {
      let arr = new Array(logData["outcome"]["userAnswer"][0]["ans"].length).fill(false);
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <>
      <Grid
        className={styles.scrollBar}
        sx={{
          flexDirection: 'row', justifyContent: 'flex-start',
          display: 'inline-flex', flexWrap: 'wrap', px: 3, pb: 2, height: '67vh',
          overflow: 'auto'
        }}>
        {logData &&
          logData["outcome"] &&
          logData["outcome"]["userAnswer"] &&
          logData["outcome"]["userAnswer"][0]["ans"].map(
            (page, index) => {
              return (
                <Box 
                  key={`${'book_eval_' + index}`}
                  sx={{ mt: 2, }}
                >
                  {page["recordedAudio"] && (
                    <Card className={styles.card} key={`page_${index}`} sx={{ mx: 3 }}>
                      <CardHeader
                        sx={{ backgroundColor: '#F5F7FF', color: 'primary.main', fontWeight: '600' }}
                        // action={
                        //   <IconButton>
                        //     <RemoveRedEyeIcon />
                        //   </IconButton>
                        // }
                        titleTypographyProps={{ fontWeight: '600', fontSize: '1.2rem' }}
                        title={`Page ${index + 1}`}
                      />
                      <CardMedia>
                        <AudioButton
                          userAnswer={
                            page["recordedAudio"]
                          }
                          playStatus={(status, end) => setPlayMode(status, index, end)}>
                          <IconButton
                            sx={{
                              color: "#DB8829",
                              backgroundColor: "#FFFFFF",
                              mx: 1,
                              padding: 0,
                              width: '9em',
                              height: '3em',
                              
                            }}
                          >                            
                            {currentIndexPlay[index] && (
                              <PauseIcon
                                sx={{
                                  width: '9em',
                                  height: '2em',
                                  padding: 1,
                                  color: "#DB8829",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2.2rem",
                                  },
                                }}
                              />
                            )}
                            {!currentIndexPlay[index] && (
                              <MusicNoteIcon
                                sx={{
                                  width: '9em',
                                  height: '2em',
                                  padding: 1,
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2.2rem",
                                  },
                                }}
                              />
                            )}
                          </IconButton>
                        </AudioButton>
                      </CardMedia>
                      <CardActions sx={{}}>
                        <SelectEvaluateComponent
                          fetchBySelectedValue={(selectedEval) => {
                            props.scoreSelect(selectedEval, index);
                          }}
                          disableVal={false}
                        />
                      </CardActions>
                    </Card>
                  )}
                </Box>
              );
            }

          )}
      </Grid>
    </>
  );
};
const useStyles = makeStyles({
  card: {
    backgroundColor: "#fff",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "3rem",
    '@media (min-width: 1636px)': {
    }
  },  
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default AssessBookEvaluate;
